/** A server timestamp as microseconds since the epoch. `Date.parse` keeps
 * milliseconds only, and two writes the server stamps in the same
 * millisecond would read as one. Python leaves the fraction out when it is
 * zero. */
function microseconds(stamp: string): number {
  const fraction = /\.(\d+)/.exec(stamp)?.[1] ?? "";
  const whole = Date.parse(stamp.replace(/\.\d+/, ""));
  return whole * 1000 + Number(fraction.padEnd(6, "0").slice(0, 6));
}

/** False when either stamp is missing: a shared link's write answers with
 * no dashboard, so with no `modifiedAt`. */
export function isLaterStamp(
  stamp: string | undefined,
  than: string | undefined,
): boolean {
  if (stamp === undefined || than === undefined) return false;
  return microseconds(stamp) > microseconds(than);
}
